/**
 * RBAC permission registry — must stay in sync with /app/backend/permissions.py
 *
 * Each module has exactly two actions: `view` and `edit`.
 * `edit` implies `view`.
 */

export const PERMISSION_MODULES = [
  { key: 'class_manager',         label: 'Class Manager' },
  { key: 'ai_schedule_generator', label: 'AI Schedule Generator' },
  { key: 'class_types',           label: 'Class Types' },
  { key: 'instructors',           label: 'Instructors' },
  { key: 'studios',               label: 'Studios' },
  { key: 'schedule_templates',    label: 'Schedule Templates' },
  { key: 'credit_packages',       label: 'Credit Packages' },
  { key: 'members',               label: 'Members' },
  { key: 'bookings',              label: 'Bookings' },
  { key: 'payments',              label: 'Payments' },
  { key: 'payment_links',         label: 'Payment Links' },
  { key: 'crm',                   label: 'CRM' },
  { key: 'coupons',               label: 'Coupons & Offers' },
  { key: 'referral_program',      label: 'Referral Program' },
  { key: 'content_management',    label: 'Content Management' },
  { key: 'theme_settings',        label: 'Theme Settings' },
  { key: 'contact_page',          label: 'Contact Page' },
  { key: 'audit_logs',            label: 'Audit Logs' },
  { key: 'email_broadcast',       label: 'Email Broadcast' },
  { key: 'roles',                 label: 'Roles & Permissions' },
];

export const ALL_PERMISSION_KEYS = PERMISSION_MODULES.flatMap(m => [
  `${m.key}.view`,
  `${m.key}.edit`,
]);

/**
 * Resolve a permission for a given user object (member from AuthContext).
 * Super admins (is_admin=true) bypass and have everything.
 */
export function userHasPermission(user, key) {
  if (!user) return false;
  if (user.is_admin) return true;
  const perms = user.permissions || {};
  return Boolean(perms[key]);
}

/**
 * Enforce "edit implies view" invariant client-side.
 */
export function normalizePermissions(raw) {
  const valid = new Set(ALL_PERMISSION_KEYS);
  const out = {};
  Object.entries(raw || {}).forEach(([k, v]) => {
    if (valid.has(k) && v) out[k] = true;
  });
  PERMISSION_MODULES.forEach(m => {
    if (out[`${m.key}.edit`]) out[`${m.key}.view`] = true;
  });
  return out;
}
